/* eslint max-len: 0 */
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import i18n from '../libs/i18n';

import Section from './Section.jsx';
import { Layout, LayoutItem } from './Layout';
import { Gallery, GalleryItem } from './Gallery';

function mapStateToProps(state) {
  const { places } = state;

  return { items: places.items };
}

@connect(mapStateToProps)
export default class SectionPlaces extends React.Component {
  static propTypes = {
    items: PropTypes.array,
    onSlideChange: PropTypes.func,
    onSlideClick: PropTypes.func,
  };

  constructor(props) {
    super(props);

    // Set initial state
    this.state = {
      currentSlide: 0,
      isZoomoutOpen: false,
    };
  }

  render() {
    const { items, onSlideChange, onSlideClick } = this.props;
    const contentBg = require('images/places-bg.svg');
    const title = i18n.translate('places.title');

    return (
      <Section id={'places'} color={'white'} contentBg={contentBg}>
        <h1>{title}</h1>
        <Layout direction={'column'}>
          <LayoutItem>
            <Layout direction={'column'} fallbackToRowAt={'medium-screens'}>
              <LayoutItem weight={2}>
                <p>{i18n.translate('places.p1')}</p>
                <p dangerouslySetInnerHTML={{ __html: i18n.translate('places.p2') }}></p>
              </LayoutItem>
              <LayoutItem weight={1} />
            </Layout>
          </LayoutItem>
          <LayoutItem>
            <Gallery slidesToShow={4} color="black" small onSlideChange={onSlideChange} hideDotCursor>
              {items.map((i, index) => {
                const slideClickHandler = () => {
                  onSlideClick(index);
                };

                return (
                  <GalleryItem key={`gallery-item-${index}`} {...i} onClick={slideClickHandler} />
                );
              })}
            </Gallery>
          </LayoutItem>
        </Layout>
      </Section>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./web/js/components/SectionPlaces.jsx
 **/